const config = {
    basename: '',
    defaultPath: '/',
    fontFamily: "'Poppins', sans-serif",
    borderRadius: 16
};

export default config;
